import { defineStore } from "pinia";

export const useChatbotStore = defineStore({
  id: "Chatbot",
  state: () => {
    return {
      messages: [
        {
          content: "Bonjour, en quoi puis-je vous aider ?",
          writer: "chatbot",
        },
      ],
      userSecretKey: null,
      loading: false,
    };
  },

  actions: {
    storeMessage(message, container) {
      this.messages.push(message);
      this.scrollToBottom(container);
    },
    clear() {
      this.messages = [];
    },
    async chatbotRequest(message, container, model) {
      this.loading = true;
      const url = process.env.VUE_APP_CHATBOT_SERVEUR_URL + "/api/chatbot";

      if (!this.userSecretKey && sessionStorage.getItem("studea-userSecretKey")) {
        this.userSecretKey = sessionStorage.getItem("studea-userSecretKey");
      }

      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "text/event-stream",
        },
        body: JSON.stringify({ message: message.content, user_secret_key: this.userSecretKey }),
      });

      if (!response.ok) {
        const errorBody = await response.json();
        throw new Error(
          `generateImage HTTP error! status: ${response.status} ${response.statusText}. Details: ${JSON.stringify(errorBody)}`,
        );
      }

      const reader = response.body.getReader();
      const decoder = new TextDecoder();
      let listen = true;
      let buffer = "";
      while (listen) {
        const { value, done } = await reader.read();
        if (done) break;

        buffer += decoder.decode(value, { stream: true });

        const parts = buffer.split("\n\n");
        buffer = parts.pop();

        for (const part of parts) {
          if (part.startsWith("data:")) {
            const jsonStr = part.replace(/^data:\s*/, "");
            try {
              const res = JSON.parse(jsonStr);
              if (res && res.response_status_code === 200) {
                const content = {
                  content: "",
                  response: res.response,
                  writer: "Chatbot",
                  id: Date.now().toString(36) + Math.random().toString(36).slice(2),
                };
                this.userSecretKey = res.user_secret_key;
                sessionStorage.setItem("studea-userSecretKey", res.user_secret_key);
                this.storeMessage(content);
                this.write(content, container, model);
                if (res.request_finished) {
                  this.loading = false;
                  listen = false;
                }
              }
            } catch (err) {
              console.error("Erreur JSON :", err, jsonStr);
            }
          }
        }
      }
    },

    write(message, container, model, suggestions = false) {
      let start = 0;

      this.interval = setInterval(() => {
        const char = message.response[start];

        if (char === "<") {
          start = message.response.indexOf(">", start);
        }

        const content = message.response.slice(0, start);
        this.writeContent(message.id, content);
        this.scrollToBottom(container);
        if (++start > message.response.length) {
          this.cancelWriting();
          if (!suggestions) {
            model.vars.disabled = false;
            this.focusInput();
          } else {
            model.vars.disabled = true;
          }
        }
      }, this.intervalLength);
    },

    focusInput() {
      const input = document.getElementById("user_chatbot");
      setTimeout(() => {
        input.focus();
      }, 50);
    },

    cancelWriting() {
      clearInterval(this.interval);
      this.interval = null;
    },

    scrollToBottom(element) {
      if (element) {
        setTimeout(function () {
          element.scroll({
            top: element.scrollHeight,
            behavior: "smooth",
          });
        }, 5);
      }
    },

    chatbotLoading() {
      this.loading = true;
    },
    chatbotSuccess() {
      this.loading = false;
    },
    writeContent(id, value) {
      const message = this.messages.find((message) => message.id === id);
      if (message) {
        message.content = value;
      }
    },
    init() {
      this.messages = [
        {
          content: "Bonjour, en quoi puis-je vous aider ?",
          writer: "chatbot",
        },
      ];
      this.loading = false;
    },
  },
});
